export default __webpack_public_path__ + "static/media/homeBG.fcc280b7.jpg";